import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'
import jsonToFormData from 'json-form-data'

@Injectable()
export class LayerService {
  constructor(private http: HttpClient) {}

  public fetchLayers(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/layer/list`
    return this.http.post(url, params)
  }
  public fetchLayer(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/layer/${id}`
    return this.http.get(url, {})
  }

  public deleteLayer(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/layer/${id}`
    return this.http.delete(url)
  }

  public createLayer(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/layer`
    return this.http.post(url, params)
  }

  public updateLayer(id: number, params: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/layer/${id}`
    return this.http.put(url, params)
  }

  public uploadLayerFile(id: number, file: File): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/layer/${id}`
    return this.http.post(`${url}/upload`, jsonToFormData({ file }))
  }
}
